export const loginPhrases = {
    notRegister: {
        title: "Opa! Este dispositivo nao esta protegido",
        helper: "Por favor defina uma senha para a sua protecao para o uso neste dispositivo",
        small: "Esta senha nao deve ser a mesma da conta, mas uma nova senha para proteger sua sessao durante o uso."
    },
    isRegister: {
        title: "Dispositivo protegido",
        helper: "Utilize a senha de protecao cadastrada neste dispositivo.",
        small: "Esta senha ja foi definida."
    },
    button: {
        isRegister: "Desbloquear",
        notRegister: "Cadastrar senha"
    }
}